import { createRoot } from 'react-dom/client';
import Shell from './Shell';
import 'typeface-roboto';
import './index.scss';
import './suppressReactRouterWarnings';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Shell />);

window.isUpdateAvailable = new Promise((resolve, reject) => {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => {
        // eslint-disable-next-line no-param-reassign
        reg.onupdatefound = () => {
          const installingWorker = reg.installing;
          installingWorker.onstatechange = () => {
            switch (installingWorker.state) {
              case 'installed':
                if (navigator.serviceWorker.controller) {
                  // new update available
                  resolve(true);
                } else {
                  // no update available
                  resolve(false);
                }
                break;
              default:
                break;
            }
          };
        };
      })
      .catch(reject);
  } else { resolve(false); }
});
